
import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';

import warningIcon from './../../assets/warning.svg';
import styles from './browser-incompatible.module.scss';

const BrowserIncompatible = () => {
  //Flush all user credentials
  useEffect(()=>{
    localStorage.clear();
  })
  return (
    <Container className={styles['content-wrapper']}>
      <div className={styles['container']}>
        <div>
          <img src={warningIcon}/>
        </div>
        <div className={styles['title']}>
          Browser Not Supported 
        </div>
        <div className={styles['body']}>
          Incompatible Browser. Your session has expired. Contact your selling agent.
        </div>
      </div>
    </Container>
  )
}

export default BrowserIncompatible;




